import GoogleTransitSearch from './GoogleTransitSearch';

export default GoogleTransitSearch;
